import React, { useState, useRef } from 'react';

import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { FaBarcode, FaQrcode } from 'react-icons/fa';
import { AxiosInstance } from 'axios';
import { useModal } from '../../../../../../hooks/Modal';

import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';

import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import Button from '../../Forms/Button';

import { usePrinter } from '../../../../../../hooks/PrinterHook';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import api from '../../../../../../services/api';
import { decodeCracha } from '../Cracha';
import { string } from 'yup';
import { Form } from '@unform/web';
import SelectSimple from '../../Forms/SelectSimple';
import Select from 'react-select/src/Select';
import CheckboxInput from 'src/components/Forms/CheckboxInput';


interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef?: AxiosInstance;
}

export default function CrachaLote({ idKey = '' }): JSX.Element {
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { addPrint, printIt } = usePrinter();
  const { configuration } = useConfiguration();
  const key = uuid();



  const print = () => {
    printIt();
  };

   const printData = (data, rows) => {

 

     let html: Array<JSX.Element> = [];

     const dataRows = data?.category_id?.length > 0 ? rows?.filter(i => { 
    
      const index = data?.category_id?.findIndex( a => a === i?.category_id)
      
      if(index >= 0){
        return true;
      }

      return false;
       
    
    
    }) : rows;

 
 

    if (dataRows) {
      dataRows?.map((line, index) => {
     
        html.push(<>  <div className="qrHolder2" style={{ display: 'flex', width: '100%', minWidth: '8.7cm', justifyContent: 'space-between', alignItems: 'center', padding: '15px', paddingBottom: '0px', paddingTop: configuration?.theme_data?.cracha_margin_top_line ? configuration?.theme_data?.cracha_margin_top_line : '0px' }}>

          <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', paddingRight: '20px' }}>
            {decodeCracha(line, configuration?.cracha_config)}
          </div>
          {configuration?.cracha_have_qrcode !== 'no' && line?.user_hash ? <div style={{ width: '80px', minWidth: '80px' }}><QRCode
            size={80}
            value={line.user_hash} renderAs="svg" /></div> : <></>}

        </div><div className="breakPage" /></>);

      });

    }


    addPrint(
      html
    );

 const keyModal = addModal({ title: '', content: <div className='column full-width gap-sm'>
  <p>{html?.length} crachás</p>
       <button onClick={() => {printIt(); }} className='greenButton2'>Imprimir</button>
 {html}
 </div>, key: 'load2' });
 



   }


  const handleQR = async (): Promise<void> => {





    const data = await api.get(`/v4/search-credenciados/${configuration?.url}`  );

    const dataRows = data?.data?.rows || [];


    const optionsCategory : any = [ ];
 
    
    dataRows?.map( i => {

 

      if(i?.category_id){
        const category =  i.category_id.toString().trim().toUpperCase();


             i.category_id = category;
      const index = optionsCategory?.findIndex( a => a?.value === category);

        if(index < 0){
          console.log(category)
          optionsCategory.push({label: category, value: category, id: category,})
        }

      }




    })

    optionsCategory.sort((a,b) => a?.label < b?.label ? -1 : a?.label > b?.label ? 1 : 0);


    const content = <> 
    

    <Form onSubmit={(data) => printData(data, dataRows)}>
         <br/>
  <button className='greenButton2'>Preparar Lista</button>
      <br/>
      <h3 style={{fontSize:'14px',padding: '10px',color: '#333'}}>Filtrar Categorias</h3>
      <CheckboxInput placeholder='Categorias'  name='category_id' options={optionsCategory}/>
      
        <button className='greenButton2'>Preparar Lista</button>


    </Form>

    
  
    
    
    </>;

    if (content) {
      const keyModal = addModal({ title: '', content, key });
    }



  };

  const moduleQRCode = (): JSX.Element => (


    <button className="searchButton" title="Imprimir Lote de Crachás" type="button" onClick={handleQR}>
      <FaBarcode />
    </button>
  );

  return moduleQRCode();
}
